/**
 * Check if we're on a preview frontend
 */
const isPreviewFrontend = () => {
  return window.location.hostname === "preview-fe.dcams.app" ||
    window.location.hostname.includes("fe-dcams.pages.dev");
};

/**
 * Get the edge API base URL based on the current hostname.
 * Uses preview.dcams.app for preview-fe.dcams.app and pages.dev deployments.
 * Uses dcams.app for production.
 */
export const getEdgeBaseUrl = () => {
  return isPreviewFrontend() ? "https://preview.dcams.app" : "https://dcams.app";
};

/**
 * Get the edge session URL
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeSessionUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/get_session";
  }
  return process.env.REACT_APP_EDGE_SESSION_URL ||
    "https://dcams.app/edge/frontend/api/get_session";
};

/**
 * Get the edge queue URL
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeQueueUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/queue/batch";
  }
  return process.env.REACT_APP_EDGE_QUEUE_URL ||
    "https://dcams.app/edge/frontend/api/queue/batch";
};

/**
 * Get the edge status URL
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeStatusUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/frontend/api/status";
  }
  return process.env.REACT_APP_EDGE_STATUS_URL ||
    "https://dcams.app/edge/frontend/api/status";
};

/**
 * Get the edge retrieve URL (for IDMax)
 * Always uses hostname-based URL for preview, env var only for production
 */
export const getEdgeRetrieveUrl = () => {
  if (isPreviewFrontend()) {
    return "https://preview.dcams.app/edge/backend/api/idmax/retrieve";
  }
  return process.env.REACT_APP_EDGE_RETRIEVE_URL ||
    "https://dcams.app/edge/backend/api/idmax/retrieve";
};
